// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"8":"7e36634818fef78549f0","332":"f7aa5fc7f1e17046709e"}[chunkId] + ".js";
};